<template>
  <div id="Home">
    <div><img :src="firstBanner" alt="" width="100%"  style="vertical-align:top"></div>
    <div class="contentWarp">
        <Sidebar />
        <div class="main-warp">
          <Navbar />
          <router-view class="page-warp" />
        </div>
    </div>
 
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from '@/components/Sidebar'
import Navbar from '@/components/Navbar'
import firstBanner from '@/assets/firstBanner.png'
export default {
  name: 'home',
  components: {
    Sidebar,
    Navbar
  },
  data() {
    return {
      firstBanner:firstBanner
    }
  },
}
</script>
<style lang="less" scope>
#Home {
  height: 100%;
  display: flex;
  flex-direction: column;
  .contentWarp{
    display: flex;
    // height: 100%;
    flex: 1;
  }
  .main-warp {
    flex: 1;
    flex-direction: column;
    overflow: auto;
    display: flex;
    .page-warp {
      overflow: auto;
      padding: 10px;
      flex: 1;
    }
  }
}
</style>
